const contingencyAccess = ["coordenador", "adm"];

export function isUserTechnician() {
  const store = JSON.parse(localStorage.getItem("vuex"));
  return contingencyAccess.includes(store.userData?.perfil);
}
